import { Button, Form, Select, Skeleton } from 'antd';
import { useLazyGetAdminOrganizationsQuery } from 'app/services/edpApiV1/admins';
import { TOrganizationResponse } from 'app/services/edpApiV1/moderator';
import React, { FC, useEffect, useRef, useState } from 'react';
import { ORGANIZATION, ORGANIZATION_ID } from 'shared/constants/admins';

const SIZE = 10;
let timeout: any;

type TOrganizationInputProps = {
  organizationChanged: (value: string) => void;
  isSearchField: boolean;
  allowClear?: boolean;
  onClear?: () => void;
};

const OrganizationInput: FC<TOrganizationInputProps> = ({
  organizationChanged,
  isSearchField = false,
  allowClear = false,
  onClear,
}) => {
  const page = useRef<number>(1);
  const [orgsArray, setOrgsArray] = useState<TOrganizationResponse[]>([]);
  const [getOrganizations, organizations] = useLazyGetAdminOrganizationsQuery();

  const fromOnChange = useRef<boolean>(false);

  useEffect(() => {
    getOrganizations({ page: page.current, size: SIZE, search: '' });
  }, []);

  useEffect(() => {
    if ((organizations.data?.length ?? 0) > 0) {
      if (fromOnChange) {
        setOrgsArray(prev => organizations.data!);
      } else {
        setOrgsArray(prev => [...orgsArray, ...organizations.data!]);
      }
      fromOnChange.current = false;
    }
  }, [organizations.data]);

  // бесконечный скролл, запрашиваем организации до момента, пока не придут все
  // const handleScroll = (scrollEvent: React.UIEvent<HTMLDivElement, UIEvent>) => {
  //   const { target } = scrollEvent;
  //   if (target instanceof HTMLDivElement) {
  //     if (target.scrollHeight - target.scrollTop === target.clientHeight) {
  //       if ((organizations.data?.pagination?.total ?? 0) > orgsArray?.length) {
  //         getOrganizations({ page: ++page.current, size: SIZE, search: '' });
  //       }
  //     }
  //   }
  // };

  const onSearch = (val: string) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fromOnChange.current = true;
      getOrganizations({ page: page.current, size: SIZE, search: val });
    }, 500);
  };

  const onSelect = (val: string) => {
    organizationChanged(val);
  };

  return (
    <Form.Item
      name={isSearchField ? ORGANIZATION_ID : ORGANIZATION}
      label={isSearchField ? '' : 'Организация'}
      rules={[{ required: true, message: 'Выберите организацию!' }]}
    >
      <Select
        placeholder="Выберите организацию для поиска сотрудника"
        // onPopupScroll={handleScroll}
        showSearch
        allowClear={allowClear}
        onClear={onClear}
        loading={organizations.isLoading || organizations.isFetching}
        style={{ minWidth: 200 }}
        filterOption={false}
        onSearch={onSearch}
        onSelect={onSelect}
        options={orgsArray.map(org => ({ label: org.name, value: org.id }))}
      />
    </Form.Item>
  );
};

export default OrganizationInput;
